import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppState } from '../../../../app.reducer';
import { Store } from '@ngrx/store';
import { GetTemplates } from '../store/templates.actions';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSlideToggleChange, MatTableDataSource } from '@angular/material';
import { GetConfigurations } from '../../configurations/store/configurations.actions';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { TestTemplateDialog } from '../test-template-dialog/test-template-dialog.component'



@Component({
  selector: 'app-templates-list',
  templateUrl: './templates-list.component.html',
  styleUrls: ['./templates-list.component.scss']
})
export class TemplatesListComponent implements OnInit, OnDestroy {

  displayedColumns: string[] = ['Template Name', 'Subject', 'Body', 'Action']
  templates: any
  dataSource: MatTableDataSource<any>;
  showEditTemplate: boolean = true;
  stopper$: Subject<any> = new Subject();

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.store.dispatch(new GetTemplates())
    this.store.select(state => state.template.templates)
      .subscribe((templates: any) => {
        this.dataSource = new MatTableDataSource(templates);
      })
    this.store.dispatch(new GetConfigurations());
    this.store.select(state => state.configurations.configurations).pipe(takeUntil(this.stopper$)).subscribe((resp: any) => {
      let configurations = Object.keys(resp);
      let index = configurations.findIndex(configuration => configuration === 'editTemplate');
      if (index !== -1) {
        let value = (resp['editTemplate']).value
        this.showEditTemplate = ((value == "true") || (value == true)) ? true : false;
        // if (!this.showEditTemplate) {
        //   this.displayedColumns.splice(this.displayedColumns.indexOf('Action'), 1)
        // }
      }
    })

  }

  editTemplate(id) {
    this.router.navigate(['../edit-template/' + id], { relativeTo: this.activatedRoute });
  }

  testTemplate(id) {
    const dialogref = this.dialog.open(TestTemplateDialog, {
      hasBackdrop: true,
      width: '700px',
      panelClass: 'cmp-modal',
      data: {
        id: id
      }
    });

  }

  ngOnDestroy() {
    this.stopper$.next();
    this.stopper$.complete();
  }
}
